import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TournamentEventsComponent } from './tournament-events.component';
import { TournamentEventGameComponent } from './tournament-event-game/tournament-event-game.component';
import { TournamentEventMediaComponent } from './tournament-event-media/tournament-event-media.component';
import { ButtonModule, DropdownModule, ProgressModule, ShareModule, SvgIconModule, TextFieldModule, UtilsModule } from '@mtgame/ui';
import { TournamentMediaModule } from '../tournament-media/tournament-media.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { TournamentEventNewsComponent } from './tournament-event-news/tournament-event-news.component';
import { NewsDetailComponent } from './news-detail/news-detail.component';
import { SharedModule } from '@shared/shared.module';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    UtilsModule,
    SvgIconModule,
    TournamentMediaModule,
    ButtonModule,
    ProgressModule,
    DropdownModule,
    TextFieldModule,
    RouterModule,
    ShareModule,
    SharedModule,
  ],
  declarations: [
    TournamentEventsComponent,
    TournamentEventGameComponent,
    TournamentEventMediaComponent,
    TournamentEventNewsComponent,
    NewsDetailComponent,
  ],
  exports: [
    TournamentEventsComponent,
    TournamentEventGameComponent,
    TournamentEventMediaComponent,
    TournamentEventNewsComponent,
    NewsDetailComponent,
  ]
})
export class TournamentEventsModule {}
